import * as yup from "yup";
import { selectOptionSchema } from "forms/schemas";

export const requestContractSchema = yup.object({
  product: selectOptionSchema.required("Product is required"),
  startShipDate: yup.date().required("Starting Ship Date is required"),
  endShipDate: yup
    .date()
    .required("Ending Ship Date is required")
    .min(
      yup.ref("startShipDate"),
      "Ending Ship Date must be on or after Starting Ship Date"
    ),
  quantity: yup
    .number()
    .min(1, "Quantity must be ${min} or more")
    .max(100000, "Quantity must be ${max} or less")
    .required("Quantity is required"),
  poNumber: yup
    .string()
    .optional()
    .matches(/^[^,\n\r\t]*$/, "PO # cannot contain comma, tab, or newline")
    .max(100, "PO # must be 100 characters or less"),
  lineItems: yup
    .array(
      yup.object().when({
        is: (value: Record<string, SelectOption | null>) =>
          Object.values(value).some((value) => value !== null),
        then: (schema) =>
          schema.shape({
            shipFrom: selectOptionSchema.required("Ship From is required"),
            shipTo: selectOptionSchema.required("Ship To is required"),
            mode: selectOptionSchema.required("Mode is required"),
            salesTerms: selectOptionSchema.required("Sales Terms is required"),
          }),
        otherwise: () => yup.object(),
      })
    )
    .min(1, "At least ${min} contract line item is required")
    .max(5, "There can only be at most ${max} contract line items"),
});
